import controller from "./analyticsCustomReports.controller";

/* analyticsCustomReports.component.js */

/**
 * @desc component for Analytics Custom Reports
 * @example <analytics-custom-reports></analytics-custom-reports>
 */

const analyticsCustomReports = {
    controller: controller,
    controllerAs: 'acrvm',
    templateUrl: '/App/Components/analyticsCustomReports/analyticsCustomReports.html'
};

export default analyticsCustomReports;